import { type JSX, useMemo } from 'react';

import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { Effectiveness, OperationalControl, numberAsEffectiveness } from 'Models/OperationalControls';

interface ControlTableProps {
    controls: OperationalControl[];
    limit?: number;
}

/**
 * Renders a sortable table of controls with "Control", "Effectiveness", and "Last Review Date" columns.
 */
export const ControlTable = (props: ControlTableProps): JSX.Element => {
    const controlsToDisplay = useMemo(() => {
        return props.limit !== undefined ? props.controls.slice(0, props.limit) : props.controls;
    }, [props.controls, props.limit]);

    const columns: ColumnConfig<OperationalControl>[] = [
        {
            type: ColumnType.CONTROL,
            name: 'Control',
            getControl: (control) => control,
        },
        {
            type: ColumnType.CONTROL_EFFECTIVENESS,
            name: 'Effectiveness',
            getControlEffectiveness: (control) => numberAsEffectiveness(control.effectiveness.control_effectiveness) as Effectiveness,
        },
        {
            type: ColumnType.DATE,
            name: 'Last Review Date',
            getDateString: (control) => control.effectiveness.last_updated,
        },
    ];

    return <Table<OperationalControl> columns={columns} defaultSortColumn="Control" filters={[]} getUniqueIdForRow={(control) => control.identifier} rowsData={controlsToDisplay} />;
};
